/* ═══════════════════════════════════════════════════════════
   RAREITEM — Predictive Search
   - โหมดหลัก (ถ้าตั้งค่า URL ไว้ใน Theme settings → "ค้นหาภาษาไทย"):
     Thai Search Worker — ค้นแบบ contains ภาษาไทย พิมพ์ "ต" เจอทุกคำที่มี ต
     เรียงขึ้นต้นก่อน + รองรับ wildcard (ต* / *ต* / *ต) แบบเงียบ ๆ
     ถ้า Worker ล่ม → ถอยไปโหมด section rendering อัตโนมัติชั่วคราว (60 วิ)
     และกด Enter ยังค้นผ่าน /search ปกติของ Shopify ได้เสมอ
   - โหมดรอง: Shopify Predictive Search API (/search/suggest.json)
   - ถ้า API ไม่รองรับภาษาของร้าน (HTTP 417/422 เช่น ภาษาไทย)
     สลับเป็นโหมดสำรองอัตโนมัติ: Section Rendering API
     (/search?section_id=predictive-fallback) ซึ่งใช้ระบบค้นหาปกติ
     ของ Shopify ที่รองรับทุกภาษา — ข้อมูลจริงทุกโหมด ไม่มี hardcode
   - หน่วง 280ms · คีย์บอร์ด ↑/↓/Enter · ปิดด้วย Escape หรือคลิกนอกกล่อง
   ═══════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var forms = document.querySelectorAll('form[data-predictive-search]');
  if (!forms.length) return;

  /* 'api' → suggest.json | 'section' → section rendering (จำข้ามหน้าใน sessionStorage) */
  var MODE_KEY = 'rareitem-ps-mode';
  var mode = 'api';
  try { mode = sessionStorage.getItem(MODE_KEY) || 'api'; } catch (e) { /* private mode */ }
  function setMode(m) {
    mode = m;
    try { sessionStorage.setItem(MODE_KEY, m); } catch (e) { /* ignore */ }
  }
  /* Worker ล่มเมื่อไร พักการเรียกชั่วคราวแล้วใช้โหมดสำรอง — หายเองไม่ต้องรีเฟรช */
  var workerDownUntil = 0;
  var uid = 0;

  function formatMoney(amountStr, moneyFormat) {
    var n = parseFloat(amountStr);
    if (isNaN(n)) return amountStr;
    var display = n % 1 === 0
      ? n.toLocaleString('en-US')
      : n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    if (moneyFormat) {
      return moneyFormat.replace(/{{\s*amount[^}]*}}/g, display);
    }
    return display;
  }

  forms.forEach(function (form) {
    var input = form.querySelector('input[type="search"]');
    if (!input) return;

    var searchUrl = form.getAttribute('data-predictive-search') || '/search/suggest';
    var thaiSearchUrl = (form.getAttribute('data-thai-search') || '').replace(/\/+$/, '');
    var moneyFormat = form.getAttribute('data-money-format') || '';
    var listId = 'PredictiveList-' + (++uid);

    var list = document.createElement('div');
    list.className = 'suggest';
    list.id = listId;
    list.setAttribute('role', 'listbox');
    list.setAttribute('aria-label', 'สินค้าที่แนะนำ');
    list.hidden = true;
    form.appendChild(list);

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', listId);
    input.setAttribute('aria-expanded', 'false');

    var debounceTimer = null;
    var controller = null;
    var activeIndex = -1;

    function close() {
      list.hidden = true;
      list.innerHTML = '';
      activeIndex = -1;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
    }

    function options() {
      return list.querySelectorAll('[role="option"]');
    }

    function setActive(index) {
      var opts = options();
      if (!opts.length) return;
      activeIndex = (index + opts.length) % opts.length;
      opts.forEach(function (o, i) {
        o.setAttribute('aria-selected', i === activeIndex ? 'true' : 'false');
      });
      input.setAttribute('aria-activedescendant', opts[activeIndex].id);
    }

    function esc(s) {
      return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    function render(products) {
      if (!products.length) {
        list.innerHTML = '<div class="suggest__empty">ไม่พบสินค้าที่ตรงกับคำนี้ — กดปุ่ม "ค้นหา" เพื่อค้นทั้งร้าน</div>';
      } else {
        /* สินค้าที่ราคา 0 = ยังไม่ได้ตั้งราคาที่ JST — ไม่ต้องเสนอในช่องค้นหา */
        products = products.filter(function (p) { return Number(p.price) !== 0; });
        list.innerHTML = products.map(function (p, i) {
          var imgUrl = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
          var img = imgUrl
            ? '<img src="' + esc(imgUrl + (imgUrl.indexOf('?') >= 0 ? '&' : '?') + 'width=72') + '" alt="" width="36" height="36" loading="lazy">'
            : '<span class="suggest__noimg" aria-hidden="true"></span>';
          return '<a role="option" id="' + listId + '-opt-' + i + '" aria-selected="false" href="' + esc(p.url) + '">' +
            img +
            '<span class="suggest__title">' + esc(p.title) + '</span>' +
            '<span class="suggest__price">' + esc(formatMoney(p.price, moneyFormat)) + '</span>' +
          '</a>';
        }).join('');
      }
      list.hidden = false;
      activeIndex = -1;
      input.setAttribute('aria-expanded', 'true');
      input.removeAttribute('aria-activedescendant');
    }

    /* โหมดสำรอง: ค้นด้วยระบบ search ปกติ render ผ่าน section (รองรับทุกภาษา) */
    function sectionSearch(term) {
      var url = (form.getAttribute('action') || '/search') +
        '?q=' + encodeURIComponent(term) +
        '&type=product&section_id=predictive-fallback';
      fetch(url, { signal: controller.signal })
        .then(function (res) {
          if (!res.ok) throw new Error('section search HTTP ' + res.status);
          return res.text();
        })
        .then(function (htmlText) {
          var doc = new DOMParser().parseFromString(htmlText, 'text/html');
          var opts = doc.querySelectorAll('[data-fallback-results] [role="option"]');
          if (!opts.length) {
            list.innerHTML = '<div class="suggest__empty">ไม่พบสินค้าที่ตรงกับคำนี้ — กดปุ่ม "ค้นหา" เพื่อค้นทั้งร้าน</div>';
          } else {
            list.innerHTML = '';
            opts.forEach(function (opt, i) {
              opt.id = listId + '-opt-' + i;
              list.appendChild(document.importNode(opt, true));
            });
          }
          list.hidden = false;
          activeIndex = -1;
          input.setAttribute('aria-expanded', 'true');
          input.removeAttribute('aria-activedescendant');
        })
        .catch(function (err) {
          if (err.name === 'AbortError') return;
          close();
        });
    }

    /* โหมดหลัก: Thai Search Worker (แสดงรูป/ชื่อ/ราคา/สถานะหมด เท่านั้น) */
    function renderWorker(results) {
      if (!results.length) {
        list.innerHTML = '<div class="suggest__empty">ไม่พบสินค้าที่ตรงกับคำนี้ — กดปุ่ม "ค้นหา" เพื่อค้นทั้งร้าน</div>';
      } else {
        list.innerHTML = results.map(function (p, i) {
          var img = p.image
            ? '<img src="' + esc(p.image + (p.image.indexOf('?') >= 0 ? '&' : '?') + 'width=72') + '" alt="" width="36" height="36" loading="lazy">'
            : '<span class="suggest__noimg" aria-hidden="true"></span>';
          var oos = p.available === false ? ' <span class="suggest__oos">สินค้าหมด</span>' : '';
          return '<a role="option" id="' + listId + '-opt-' + i + '" aria-selected="false" href="' + esc(p.url) + '">' +
            img +
            '<span class="suggest__title">' + esc(p.title) + oos + '</span>' +
            '<span class="suggest__price">' + esc(formatMoney(p.price, moneyFormat)) + '</span>' +
          '</a>';
        }).join('');
      }
      list.hidden = false;
      activeIndex = -1;
      input.setAttribute('aria-expanded', 'true');
      input.removeAttribute('aria-activedescendant');
    }

    function workerSearch(term) {
      /* กัน request ค้างนาน: เกิน 3 วิ ถือว่าล่ม แล้วถอยไปโหมดสำรองทันที */
      var timeout = setTimeout(function () { if (controller) controller.abort(); }, 3000);
      fetch(thaiSearchUrl + '/search?q=' + encodeURIComponent(term) + '&limit=10&instock=1', { signal: controller.signal })
        .then(function (res) {
          if (!res.ok) throw new Error('thai search HTTP ' + res.status);
          return res.json();
        })
        .then(function (data) {
          clearTimeout(timeout);
          renderWorker((data && data.results) || []);
        })
        .catch(function (err) {
          clearTimeout(timeout);
          /* AbortError จากการพิมพ์ตัวใหม่ = ปกติ แต่ abort จาก timeout = ล่ม */
          var timedOut = err.name === 'AbortError' && Date.now() - lastFire >= 2900;
          if (err.name === 'AbortError' && !timedOut) return;
          workerDownUntil = Date.now() + 60000;
          controller = new AbortController();
          sectionSearch(term); /* ถอยไปค้นด้วยระบบปกติของ Shopify ให้จบคำนี้เลย */
        });
    }
    var lastFire = 0;

    /* Skeleton — โครงกะพริบระหว่างรอผล (เฉพาะตอนกล่องยังไม่มีผลเดิมค้างอยู่ จะได้ไม่กระพริบทับของจริง) */
    function showSkeleton() {
      if (!list.hidden && list.querySelector('[role="option"]')) return;
      var row = '<div class="sk-row" aria-hidden="true"><div class="sk" style="width:36px;height:36px"></div>' +
        '<div style="flex:1"><div class="sk" style="height:10px;width:72%;margin-bottom:7px"></div>' +
        '<div class="sk" style="height:10px;width:34%"></div></div></div>';
      list.innerHTML = row + row + row;
      list.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function search(term) {
      if (controller) controller.abort();
      controller = new AbortController();
      showSkeleton();
      if (thaiSearchUrl && Date.now() >= workerDownUntil) {
        lastFire = Date.now();
        workerSearch(term);
        return;
      }
      if (mode === 'section') { sectionSearch(term); return; }
      var url = searchUrl + '.json' +
        '?q=' + encodeURIComponent(term) +
        '&resources[type]=product' +
        '&resources[limit]=5' +
        '&resources[options][unavailable_products]=hide';
      fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } })
        .then(function (res) {
          if (res.status === 417 || res.status === 422) {
            /* Predictive API ไม่รองรับภาษาของร้าน (เช่น ไทย = 417 "Unsupported buyer locale")
               → สลับเป็นโหมด section rendering ถาวรสำหรับ session นี้ */
            setMode('section');
            sectionSearch(term);
            return null;
          }
          if (!res.ok) throw new Error('predictive search HTTP ' + res.status);
          return res.json();
        })
        .then(function (data) {
          if (!data) return;
          render(data.resources.results.products || []);
        })
        .catch(function (err) {
          if (err.name === 'AbortError') return;
          close(); /* เครือข่ายผิดพลาด — ซ่อนเงียบ ๆ ค้นหาปกติยังใช้ได้ */
        });
    }

    input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      var term = input.value.trim();
      if (!term) { close(); return; }
      debounceTimer = setTimeout(function () { search(term); }, 280);
    });

    input.addEventListener('keydown', function (e) {
      if (list.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(activeIndex + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(activeIndex - 1); }
      else if (e.key === 'Enter' && activeIndex >= 0) {
        e.preventDefault();
        var opt = options()[activeIndex];
        if (opt) window.location.href = opt.getAttribute('href');
      }
      else if (e.key === 'Escape') { close(); }
    });

    /* ปิดเมื่อคลิก/แตะนอกกล่องค้นหา */
    document.addEventListener('pointerdown', function (e) {
      if (!form.contains(e.target)) close();
    });
  });
})();
